import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import Typo from 'constants/typography'
import PropTypes from 'prop-types'
import React from 'react'
import { hasLocizeTranslation } from 'lib/utils/locize'
import clsx from 'clsx'
import AverageStars from 'components/common/average-stars/AverageStars'
import ReviewsRatingsCoachMark from './reviews-ratings-coachmark/ReviewsRatingsCoachMark'
import styles from './reviews-ratings.scss'

const ReviewsRatings = ({ t, productAverageRatings }) => {
  const REVIEWS_RATINGS = [
    {
      title: hasLocizeTranslation(
        t,
        'PRODUCT_AS_DISPLAYED',
        'Product as Displayed',
      ),
      coachmarkText: hasLocizeTranslation(
        t,
        'PRODUCT_AS_DISPLAYED_COACHMARK',
        'Does the product displayed accurately represent the product you received?',
      ),
      rating: productAverageRatings?.avg_product_as_display_rating,
    },
    {
      title: hasLocizeTranslation(t, 'DESIGN_&_STYLE', 'Design & Style'),
      coachmarkText: hasLocizeTranslation(
        t,
        'DESIGN_&_STYLE_COACHMARK',
        'Aesthetic appeal of the product, including its design, color, pattern',
      ),
      rating: productAverageRatings?.avg_design_and_style_rating,
    },
    {
      title: hasLocizeTranslation(t, 'QUALITY', 'Quality'),
      coachmarkText: hasLocizeTranslation(
        t,
        'QUALITY_COACHMARK',
        'Overall quality of the product',
      ),
      rating: productAverageRatings?.avg_product_quality_rating,
    },
  ]

  return (
    <div className="reviews-ratings-container">
      <style jsx>{styles}</style>
      {REVIEWS_RATINGS.map((reviewRating) => (
        <div key={reviewRating?.title} className="review-rating-wrapper">
          <div className="review-rating-wrapper__inner">
            <div className={clsx(Typo.body2)}>{reviewRating.title} </div>
            <ReviewsRatingsCoachMark
              coachmarkText={reviewRating.coachmarkText}
            />
          </div>
          <AverageStars averageRating={reviewRating.rating} />
        </div>
      ))}
    </div>
  )
}

ReviewsRatings.propTypes = {
  // component props
  productAverageRatings: PropTypes.shape({
    avg_design_and_style_rating: PropTypes.number,
    avg_overall_product_rating: PropTypes.number,
    avg_product_as_display_rating: PropTypes.number,
    avg_product_quality_rating: PropTypes.number,
    avg_rating_true_to_size: PropTypes.string,
    total_count: PropTypes.number,
  }).isRequired,

  // redux props
  t: PropTypes.func.isRequired,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
  })),
  withI18next(),
)(ReviewsRatings)
